var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgChevronLeft = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 12.5 12.5"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.68,6a.46.46,0,0,0,0,.66h0l5.73,5.78a.48.48,0,0,0,.67,0h0l.77-.77a.47.47,0,0,0,0-.67h0L5.22,6.28,9.85,1.6a.47.47,0,0,0,0-.66h0L9.08.16a.48.48,0,0,0-.67,0h0Z"
})));
export default SvgChevronLeft;